import React, { useEffect, useState } from "react";
import { getMessages } from "../services/messageService";
import { getFamilies } from "../services/familyService";
import AddMessageForm from "./AddMessageForm";
import MessageTable from "./MessageTable";
import { MessageResponse } from "../types/MessageTypes";
import { FamilyResponse } from "../types/FamilyTypes";
import { getUserRole } from "../services/authService";

const MessageList = () => {
  const [messages, setMessages] = useState<MessageResponse[]>([]);
  const [families, setFamilies] = useState<FamilyResponse[]>([]); // Use useState to store data
  const role = getUserRole();

  useEffect(() => {
    async function fetchFamily() {
      const data = await getFamilies();  // Wait for API response
      setFamilies(data); // Update state, triggers re-render
    }

    fetchFamily();
    loadMessages();
  }, []);

  const loadMessages = async () => {
    const data = await getMessages();
    setMessages(data);
  };


  return (
    <div>
      <h1>Message List</h1>
      <AddMessageForm families={families} loadMessages={loadMessages} />
      {(role === "Admin" || role === "SuperAdmin") && 
        <MessageTable messages={messages} families={families} loadMessages={loadMessages} />}
    </div>
  );
};

export default MessageList;
